import * as index from '@syncfusion/ej2-pivotview';
index.PivotView.Inject( index.GroupingBar,index.FieldList,index.CalculatedField,index.ConditionalFormatting,index.VirtualScroll,index.DrillThrough,index.Toolbar,index.PivotChart,index.PDFExport,index.ExcelExport);
export * from '@syncfusion/ej2-pivotview';
